export const getKeyFromUrl = (key) => {
    const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg);
    return r ? unescape(r[2]) : null;
}